var config = require("./lib/config");

var luvitEduMainWin;

var luvit = luvit || {};

module.exports = luvit;

const emailRegex = /^([\w\-\.]+(\+[\w\-\.]+)*@([\w-]+\.)+[\w-]{2,4})?$/;

luvit.urlParams = {};
luvit.ua = navigator.userAgent.toLowerCase();
luvit.appPath = $("#ApplicationRoot").attr("href");
luvit.installationID;
luvit.ratingServerSetting;
luvit.mobileBreakPoint = 600;

luvit.mqMobile = window.matchMedia(
  "(max-width:" + luvit.mobileBreakPoint + "px)",
);

window.commonLanguageContextData = {};

function fetchContext(languageContext, callback) {
  var now = moment();
  var localStorageAvailable =
    window.localStorage && window.localStorage.getItem(languageContext);
  var savedTimestamp = localStorage.getItem(languageContext + "_timestamp");
  var savedTimestampDate = moment(
    savedTimestamp,
    "ddd MMM DD YYYY HH:mm:ss ZZ",
    "en",
  );
  var daysStored = now.diff(savedTimestampDate, "days") || 0;
  var shouldFetch =
    daysStored > 0 ||
    savedTimestamp === null ||
    config.culture !==
      window.localStorage.getItem(languageContext + "_culture");
  if (localStorageAvailable && !shouldFetch) {
    var data = localStorage.getItem(languageContext);
    commonLanguageContextData = JSON.parse(data);
  } else {
    ajaxSend(
      "GET",
      config.apiUrl +
        "v1/translation-strings/" +
        config.culture +
        "/" +
        languageContext,
      setContext,
      null,
      false,
      null,
      null,
      callback,
    );

    localStorage.setItem(
      languageContext,
      JSON.stringify(commonLanguageContextData),
    );
    localStorage.setItem(languageContext + "_timestamp", moment());
    localStorage.setItem(languageContext + "_culture", config.culture);
    luvit.setHtmlLanguage(config.culture);
  }
}

function setContext(data, callback) {
  commonLanguageContextData = JSON.parse(data);
  callback();
}

function getTranslation(key) {
  return key
    ? commonLanguageContextData[key.toLowerCase()] || key + " *️"
    : null;
}

/*Utils***************************************************************************************************************/

luvit.updateURLParameter = function (url, param, paramVal) {
  var newAdditionalURL = "";
  var tempArray = url.split("?");
  var baseURL = tempArray[0];
  var additionalURL = tempArray[1];
  var temp = "";
  if (additionalURL) {
    tempArray = additionalURL.split("&");
    for (var i = 0; i < tempArray.length; i++) {
      if (tempArray[i].split("=")[0] != param) {
        newAdditionalURL += temp + tempArray[i];
        temp = "&";
      }
    }
  }

  var rows_txt = temp + "" + param + "=" + paramVal;
  return baseURL + "?" + newAdditionalURL + rows_txt;
};

luvit.BreakOutChat = function (obj, id, fromEdu) {
  var fromEduQs = "&fromedu=1";

  parent.ChatWin = window.open(
    $("#ApplicationRoot").attr("href") +
      "/chat/chat_init.aspx?chatroomid=" +
      id +
      "&breakout=1" +
      fromEduQs,
    "chatwin",
    "width=800,height=600,scrollbars=yes,resizable=yes",
  );
  parent.ChatWin.focus();
  return false;
};

luvit.OpenWin = function (url, width, height) {
  return window.open(
    url,
    "",
    "width=" +
      width +
      ",height=" +
      height +
      ",toolbar=no,scrollbars=yes,resizable=yes,status=no",
  );
};

luvit.isEmpty = function (el) {
  return !$.trim($(el).html());
};

luvit.GetQueryString = function (key) {
  key = key.toLowerCase();
  var e,
    a = /\+/g, // Regex for replacing addition symbol with a space
    r = /([^&=]+)=?([^&|#]*)/g, // Added "#" as a split as it was causing issues
    d = function (s) {
      return decodeURIComponent(s.replace(a, " "));
    },
    q =
      (window.location.href.indexOf("?") >= 0 &&
        window.location.href.toLowerCase().split("?")[1]) ||
      "";

  while ((e = r.exec(q)))
    //Is correct, do not change to ==
    luvit.urlParams[d(e[1])] = d(e[2]);

  return q.indexOf(key) >= 0 ? luvit.urlParams[key] : "";
};

luvit.HideInfoSaved = function (element, delay) {
  setTimeout(function () {
    $(element).slideUp("slow");
  }, delay);
};

luvit.DelayedFadeOut = function (element, delay) {
  setTimeout(function () {
    $(element).fadeOut("slow");
  }, delay);
};

luvit.DelayedHide = function (element, delay) {
  setTimeout(function () {
    $(element).slideUp("slow");
  }, delay);
};

luvit.ForceNumericOnly = function (element) {
  $(element).keydown(function (e) {
    // Allow: backspace, delete, tab, escape, enter and .
    if (
      $.inArray(e.keyCode, [46, 8, 9, 27, 13, 110, 190]) !== -1 ||
      // Allow: Ctrl+A
      (e.keyCode == 65 && e.ctrlKey === true) ||
      // Allow: home, end, left, right
      (e.keyCode >= 35 && e.keyCode <= 39)
    ) {
      // let it happen, don't do anything
      return;
    }
    // Ensure that it is a number and stop the keypress
    if (
      (e.shiftKey || e.keyCode < 48 || e.keyCode > 57) &&
      (e.keyCode < 96 || e.keyCode > 105)
    ) {
      e.preventDefault();
    }
  });
};

luvit.IsTouchDevice = function () {
  return "ontouchstart" in window; //  || !!(navigator.msMaxTouchPoints);

  //return (('ontouchstart' in window) || window.DocumentTouch && document instanceof DocumentTouch);
};

luvit.matchAgent = function (agent) {
  if (navigator.userAgent.indexOf(agent) != -1) {
    return true;
  } else {
    return false;
  }
};

luvit.IsIPad = function () {
  var isiPad = navigator.userAgent.match(/iPad/i) != null;
  return isiPad;
};

var showOverlay = false;
luvit.InitAjaxLoadingOverlay = function () {
  /*$("body").append('<div id="DivOverlay"> </div>');
        $("#DivOverlay")
        .hide()
        .ajaxStart(function () {
        $(".innerdiv").hide();
        showOverlay = true;
        var height = $(document).height();
        $(this).height(height).css("cursor", "wait");
        overlayTimer = setTimeout('if (showOverlay) { $("#DivOverlay").show(); }', ajaxLoaderWait);
        }).ajaxStop(function () {
        showOverlay = false;
        clearTimeout(overlayTimer);
        $(this).css("cursor", "default").hide();
        $(".innerdiv").show();
        });*/

  $("body").append('<div id="overlay"> </div>');
  $("#overlay").hide();

  $(document).ajaxStart(function () {
    showOverlay = true;
    var height = $(document).height();
    $("#overlay").height(height).css("cursor", "wait");
    overlayTimer = setTimeout(
      'if (showOverlay) { $("#overlay").show(); }',
      500,
    );
  });

  $(document).ajaxStop(function () {
    showOverlay = false;
    clearTimeout(overlayTimer);
    $("#overlay").css("cursor", "default").hide();
  });
};

openedPresentations = new Array();
luvit.ShowPersonalPresentation = function (pid, cid) {
  if (luvit.appPath == "" || pid == "") {
    return false;
  }

  var hasCid = typeof cid != "undefined" && cid != "";
  var key = hasCid ? pid + cid : pid;
  var presentation = openedPresentations[key];

  //    //if this is in popup we must check if opener has opened this presentation
  if (presentation == undefined) {
    if (opener) {
      if (opener.openedPresentations) {
        presentation = opener.openedPresentations[key];
        openedPresentations = opener.openedPresentations;
      }
    }
  }

  if (openedPresentations.hasOwnProperty(key) && !presentation.closed) {
    presentation.focus();
  } else {
    var url = luvit.appPath + "/Personal/PersonalPresentation.aspx?pid=" + pid;
    if (hasCid) {
      url = url + "&cid=" + cid;
    }
    openedPresentations[key] = window.open(
      url,
      "",
      "width=800,height=650,scrollbars=yes,resizable=yes",
    );
  }

  return false;
};

luvit.InitCheckboxes = function () {
  $(document).on("click", ".chkallitems", function () {
    var tbl = $(this).closest("table");

    if (tbl.length == 0) tbl = $("body").find(".maindatatable");

    if ($(this).prop("checked")) {
      $(tbl).find('input[type="checkbox"]').prop("checked", true);
      $(tbl).find("tr").addClass("checked selected");
    } else {
      $(tbl).find('input[type="checkbox"]').prop("checked", false);
      $(tbl).find("tr").removeClass("checked selected");
    }
  });

  $(document).on("click", ".chkitem", function () {
    var tbl = $(this).closest("table");
    var tbody = $(this).closest("tbody");
    var chkAllItems = $(tbl).find(".chkallitems");
    if (tbl.length == 0) {
      tbl = $("body").find(".maindatatable");
      tbody = $(tbl).find("tbody");
      chkAllItems = $("body").find(".chkallitems");
    }

    if ($(this).prop("checked")) {
      var noOfCheckboxes = $(tbody)
        .find("td")
        .find('input[type="checkbox"]').length;
      var noOfChecked = $(tbody).find("td").find("input:checked").length;

      if (noOfChecked == noOfCheckboxes) $(chkAllItems).prop("checked", true);

      $(this).closest("tr").addClass("checked selected");
      $(this).closest("tr").removeAttr("style");
    } else {
      $(chkAllItems).prop("checked", false);
      $(this).closest("tr").removeClass("checked selected");
    }
  });
};

luvit.AtLeastOneChecked = function (element) {
  var noOfChecked = $(element).find("input:checked").length;

  if (noOfChecked > 0) return true;

  return false;
};

var log = function (msg) {
  if (window.console && window.console.log) console.log(msg);
};

luvit.setItem = function (name, value) {
  if (typeof Storage !== "undefined") {
    localStorage.setItem(name, value);
  } else {
    $.cookie(name, value, { expires: 7 });
  }
};

luvit.getItem = function (name) {
  if (typeof Storage !== "undefined") {
    var value = localStorage.getItem(name);
    if (!value) return luvit.getCookie(name);
    return value;
  } else {
    return luvit.getCookie(name);
    $.cookie(name);
  }
};

luvit.getCookie = function (cname) {
  var name = cname + "=";
  var ca = document.cookie.split(";");
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
};

luvit.removeItem = function (name) {
  if (typeof Storage !== "undefined") {
    return localStorage.removeItem(name);
  } else {
    return $.removeCookie(name);
  }
};

luvit.InitWatermarks = function () {
  var testInput = document.createElement("input");
  var testPlaceholderCompatibility = "placeholder" in testInput;

  // check placeholder browser support
  if (!testPlaceholderCompatibility) {
    $("[placeholder]").each(function () {
      if ($(this).val() == "") {
        $(this).val($(this).attr("placeholder"));
        $(this).addClass("watermarked");
      }
    });

    $("input[placeholder]")
      .focus(function () {
        if ($(this).val() == $(this).attr("placeholder")) {
          $(this).val("");
          $(this).removeClass("watermarked");
        }
      })
      .blur(function () {
        if (
          $(this).val() == "" ||
          jQuery(this).val() == jQuery(this).attr("placeholder")
        ) {
          $(this).val($(this).attr("placeholder"));
          $(this).addClass("watermarked");
        }
      });
    // remove placeholders on submit
    $("input[placeholder]")
      .closest("form")
      .submit(function () {
        $(this)
          .find("[placeholder]")
          .each(function () {
            if ($(this).val() == $(this).attr("placeholder")) {
              $(this).val("");
            }
          });
      });
  }
};

luvit.InitEnter = function (txtField, focusBtn) {
  $(txtField).keydown(function (event) {
    var keycode = event.keyCode
      ? event.keyCode
      : event.which
        ? event.which
        : event.charCode;

    if (keycode == 13) {
      $(focusBtn).focus();
      $(focusBtn)[0].click();
      return false;
    }
  });
};

luvit.GetInstallationID = function () {
  if (luvit.installationID) return luvit.installationID;

  var url = luvit.appPath + "/XmlResponse/utilsopen.aspx";

  luvit.callAjaxSync(
    url,
    "GetInstallationID",
    "",
    function (data) {
      luvit.installationID = data;
    },
    function () {
      luvit.installationID = "luvit";
    },
  );

  return luvit.installationID;
};

luvit.GetInstallationIDWithCallback = function (success) {
  if (luvit.installationID) success(luvit.installationID);

  var url = luvit.appPath + "/XmlResponse/utilsopen.aspx";

  luvit.callAjaxSync(
    url,
    "GetInstallationID",
    "",
    function (data) {
      luvit.installationID = data;
      success(data);
    },
    function () {
      success("luvit");
    },
  );
};

luvit.GetAdminServerSetting = function (settingName) {
  var url = luvit.appPath + "/XmlResponse/utils.aspx";

  luvit.callAjaxSync(
    url,
    "GetAdminServerSetting",
    '{"settingName": "' + settingName + '"}',
    function (data) {
      luvit.ratingServerSetting = data;
    },
    function () {
      return null;
    },
  );

  return luvit.ratingServerSetting;
};

luvit.FormatDate = function (formatDate, formatString) {
  if (formatDate instanceof Date) {
    var months = new Array(
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    );
    var yyyy = formatDate.getFullYear();
    var yy = yyyy.toString().substring(2);
    var m = formatDate.getMonth() + 1;
    var mm = m < 10 ? "0" + m : m;
    var mmm = months[m];
    var d = formatDate.getDate();
    var dd = d < 10 ? "0" + d : d;

    var h = formatDate.getHours();
    var hh = h < 10 ? "0" + h : h;
    var n = formatDate.getMinutes();
    var nn = n < 10 ? "0" + n : n;
    var s = formatDate.getSeconds();
    var ss = s < 10 ? "0" + s : s;

    formatString = formatString.replace(/yyyy/i, yyyy);
    formatString = formatString.replace(/yy/i, yy);
    formatString = formatString.replace(/mmm/i, mmm);
    formatString = formatString.replace(/mm/i, mm);
    formatString = formatString.replace(/m/i, m);
    formatString = formatString.replace(/dd/i, dd);
    formatString = formatString.replace(/d/i, d);
    formatString = formatString.replace(/hh/i, hh);
    formatString = formatString.replace(/h/i, h);
    formatString = formatString.replace(/nn/i, nn);
    formatString = formatString.replace(/n/i, n);
    formatString = formatString.replace(/ss/i, ss);
    formatString = formatString.replace(/s/i, s);

    return formatString;
  } else {
    return "";
  }
};

luvit.InitKeepScrollPositionOnPostback = function (element, page) {
  $($(element).contents()).scroll(function () {
    luvit.setItem(
      "luvit_" + page + "_scrollposition",
      $(element).contents().scrollTop(),
    );
  });
};

luvit.SetScrollPosition = function (element, page) {
  try {
    if (luvit.getItem("luvit_" + page + "_scrollposition")) {
      $(element)
        .contents()
        .scrollTop(luvit.getItem("luvit_" + page + "_scrollposition"));
    }
  } catch (err) {}
};

luvit.scrollToTop = function () {
  if ($(".content-iframe").length > 0) {
    $(".header").slideDown();
    $(".content-edu").css("top", "");
    var doc = document.querySelector(".content-iframe").contentDocument;
    $(doc).scrollTop(0);
  } else {
    $(document).scrollTop(0);
  }
};

luvit.TogglePortalMenuState = function (state) {
  //var state = { active: menuItemId };
  var navigationStore = require("lib/components/leftmenu/Store").default;

  navigationStore.expandToggle(state);
};

luvit.SetPortalMenuState = function (menuItemId) {
  //don't set help or luvit admin as active
  if (menuItemId != "1004" && menuItemId != "1007") {
    var state = { active: menuItemId };
    var navigationStore = require("lib/components/leftmenu/Store").default;

    navigationStore.activateNode(Number(menuItemId));

    if (luvit.getItem("luvit_portalmenustate")) {
      var menuState = $.parseJSON(luvit.getItem("luvit_portalmenustate"));
      menuState.active = menuItemId;
      luvit.setItem("luvit_portalmenustate", JSON.stringify(menuState));
    } else luvit.setItem("luvit_portalmenustate", JSON.stringify(state));
  }
};

luvit.SetCourseMenuState = function (menuItemId) {
  var state = { active: menuItemId };

  if (luvit.getItem("luvit_coursemenustate")) {
    var menuState = $.parseJSON(luvit.getItem("luvit_coursemenustate"));
    menuState.active = menuItemId;
    luvit.setItem("luvit_coursemenustate", JSON.stringify(menuState));
  } else luvit.setItem("luvit_coursemenustate", JSON.stringify(state));
};

luvit.CountOccurrences = function (string, subString, allowOverlapping) {
  string += "";
  subString += "";
  if (subString.length <= 0) return string.length + 1;

  var n = 0,
    pos = 0;
  var step = allowOverlapping ? 1 : subString.length;

  while (true) {
    pos = string.indexOf(subString, pos);
    if (pos >= 0) {
      ++n;
      pos += step;
    } else break;
  }
  return n;
};

luvit.setFileInfo = function (fileupload) {
  var fake_path = fileupload.value;
  var filename = fileupload.nextElementSibling.nextElementSibling;
  filename.innerText = fake_path.split("\\").pop();
};

luvit.isSafariBrowser = function () {
  const userAgentString = navigator.userAgent;
  const chromeAgent = userAgentString.indexOf("Chrome") > -1;
  var safariAgent = userAgentString.indexOf("Safari") > -1;

  // Discard Safari since it also matches Chrome
  if (chromeAgent && safariAgent) safariAgent = false;

  return safariAgent;
};
/*********************************************************************************************************************/

/*VALIDATION**********************************************************************************************************/

//Validates an email adress, returns true if valid otherwise false
luvit.ValidateEmail = function (email) {
  if (!emailRegex.test(email)) {
    return false;
  } else {
    return true;
  }
};

luvit.checkEmail = function (o, min, max, validationElement, errorMessage) {
  if (!emailRegex.test(o.val())) {
    o.addClass("ui-state-error");
    $(validationElement).append(errorMessage + "<br />");
    $(validationElement).show();
    o.focus();
    return false;
  } else {
    return true;
  }
};

luvit.checkLength = function (o, min, max, validationElement, errorMessage) {
  if (o.val().length > max || o.val().length < min) {
    o.addClass("ui-state-error");
    $(validationElement).append(errorMessage + "<br />");
    $(validationElement).show();
    o.focus();
    return false;
  } else {
    return true;
  }
};

luvit.matchRegex = function (o, regex, validationElement, errorMessage) {
  if (o.val().match(regex)) {
    return true;
  } else {
    o.addClass("ui-state-error");
    $(validationElement).append(errorMessage + "<br />");
    $(validationElement).show();
    o.focus();
    return false;
  }
};

luvit.checkSelect = function (o, validationElement, errorMessage) {
  if (o.val() == "0") {
    $(validationElement).append(errorMessage + "<br />");
    $(validationElement).show();
    o.focus();
    return false;
  } else {
    return true;
  }
};

luvit.isChecked = function (o, validationElement, errorMessage) {
  if (!$(o).is(":checked")) {
    $(validationElement).append(errorMessage + "<br />");
    $(validationElement).show();
    o.focus();
    return false;
  } else {
    return true;
  }
};

luvit.checkRegexp = function (o, regexp, validationElement, errorMessage) {
  if (!regexp.test(o.val())) {
    o.addClass("ui-state-error");
    $(validationElement).append(errorMessage + "<br />");
    $(validationElement).show();
    o.focus();
    return false;
  } else {
    return true;
  }
};

luvit.checkRegexpSimple = function (value, regexp) {
  if (!regexp.test(value)) {
    return false;
  } else {
    return true;
  }
};

luvit.compareFields = function (
  field1,
  field2,
  validationElement,
  errorMessage,
) {
  if (field1.val() === field2.val()) {
    return true;
  } else {
    field2.addClass("ui-state-error");
    $(validationElement).append(errorMessage + "<br />");
    $(validationElement).show();
    field1.focus();
    return false;
  }
};

/*********************************************************************************************************************/

/*AJAX****************************************************************************************************************/

//Returns a promise
//url = address to page where the webmethod is
//method = name of the web method
//params = parameters to web method in json format
luvit.ajaxGet = function (url, method, params) {
  url += "/" + method;
  return $.ajax({
    type: "POST",
    url: url,
    dataType: "json",
    contentType: "application/json; charset=utf-8",
    data: params,
  });
};

//url = address to page where the webmethod is
//method = name of the web method
//params = parameters to web method in json format
//success = function if call succeeds
//error = function if call fails
//headers = extra headers, e.g. { "MyKey1" : "MyValue1", "MyKey2" : "MyValue2" }
luvit.callAjax = function (url, method, params, success, error, headers) {
  url += "/" + method;
  $.ajax({
    type: "POST",
    headers: headers,
    url: url,
    dataType: "json",
    contentType: "application/json; charset=utf-8",
    data: params,
    success: function (response) {
      if (success != null) success(response.d);
    },
    error: function (httpRequest, textStatus, errorThrown) {
      if (error != null) {
        error(httpRequest, textStatus, errorThrown);
        // log(httpRequest.responseText);
      }
    },
  });
  return false;
};

luvit.callAjaxSync = function (url, method, params, success, error) {
  url += "/" + method;
  $.ajax({
    type: "POST",
    url: url,
    dataType: "json",
    contentType: "application/json; charset=utf-8",
    data: params,
    async: false,
    success: function (response) {
      if (success != null) success(response.d);
    },
    error: function (httpRequest, textStatus, errorThrown) {
      if (error != null) error();
    },
  });
  return false;
};

/*********************************************************************************************************************/

/**MISC***************************************************************************************************************/
luvit.ReloadNoOfUngradedAssignments = function () {
  luvit.callAjax(
    luvit.appPath + "/XmlResponse/assignments.aspx",
    "GetNoOfUngradedAssignments",
    "",
    function (data) {
      luvit.setItem("noofungradedlastupdate", new Date() + "|" + data);
      //In course
      if ($("[id*=iFrameMainContent]").length > 0) {
        $("#UngradedAssignmentsIndicator").attr(
          "href",
          luvit.appPath + "/personal/ungradedassignments.aspx?fromedu=1",
        );
        $("#UngradedAssignmentsIndicator").attr("target", "iFrameMainContent");
      } else {
        var gaHref = luvit.appPath + "/personal/ungradedassignments.aspx";

        $("#UngradedAssignmentsIndicator").attr("href", gaHref);
      }

      $("#UngradedAssignmentsIndicator").click(function () {
        var state = { active: "31" };

        if (luvit.getItem("luvit_portalmenustate")) {
          var menuState = $.parseJSON(luvit.getItem("luvit_portalmenustate"));
          menuState.active = "31";
          luvit.setItem("luvit_portalmenustate", JSON.stringify(menuState));
        } else luvit.setItem("luvit_portalmenustate", JSON.stringify(state));
      });

      $(".noofassignments", top.document).html(data);
      if (data > 0) {
        $(".assignmentnotification").show();
      } else {
        $(".assignmentnotification").hide();
      }
    },
    function () {
      $(".noofassignments").html("?");
    },
  );
};

/**Old portal_scripts.js**/
var jsddm_timeout = 1000;
var closetimer = 0;
var ddmenuitem = 0;

var courseID = "";
var personalID = "";
var currentSkin = "";

var ua = navigator.userAgent;

function jsddm_open_touch(t) {
  jsddm_canceltimer();
  luvit.jsddm_close();
  $(document).unbind("click");
  ddmenuitem = $(t).find("ul").css("visibility", "visible");
}

luvit.jsddm_open = function jsddm_open(element) {
  jsddm_canceltimer();
  luvit.jsddm_close();
  ddmenuitem = $(element).find("ul").css("visibility", "visible");
};

luvit.jsddm_close = function () {
  if (ddmenuitem) {
    ddmenuitem.css("visibility", "hidden");
    //$(ddmenuitem).slideUp();
  }
};

luvit.jsddm_timer = function jsddm_timer() {
  closetimer = window.setTimeout(luvit.jsddm_close, jsddm_timeout);
};

function jsddm_canceltimer() {
  if (closetimer) {
    window.clearTimeout(closetimer);
    closetimer = null;
  }
}

luvit.jsddm_start_touch = function jsddm_start_touch(t) {
  jsddm_open_touch(t);
  setTimeout(jsddm_bind_touch, 500);
};

luvit.jsddm_end_touch = function jsddm_end_touch() {
  jsddm_close();
  $(document).unbind("click");
};

luvit.jsddm_bind_touch = function jsddm_bind_touch() {
  $(document).bind("click", jsddm_end_touch);
};

luvit.loadPage = function loadPage() {
  if (typeof Sys == "undefined") {
    return false;
  }

  Sys.WebForms.PageRequestManager.getInstance().add_endRequest(function () {
    $(document).trigger("endrequest");
  });

  //jquery features after update of updatepanel
  Sys.WebForms.PageRequestManager.getInstance().add_endRequest(function () {
    $(document).trigger("feature", document);
  });

  if (typeof EndRequestHandler == "function") {
    Sys.WebForms.PageRequestManager.getInstance().add_endRequest(
      EndRequestHandler,
    );
  }
};

//Checked
luvit.AllowOnlyNumbers = function AllowOnlyNumbers(event) {
  if (event.shiftKey == true) {
    event.preventDefault();
  }
  // Allow Only: keyboard 0-9, numpad 0-9, backspace, tab, left arrow, right arrow, delete
  if (
    (event.keyCode >= 48 && event.keyCode <= 57) ||
    (event.keyCode >= 96 && event.keyCode <= 105) ||
    event.keyCode == 8 ||
    event.keyCode == 9 ||
    event.keyCode == 37 ||
    event.keyCode == 39 ||
    event.keyCode == 46
  ) {
    // Allow normal operation
  } else {
    event.preventDefault();
  }
};

luvit.ConfirmAction = function ConfirmAction(phrase) {
  return confirm(phrase);
};

//Checked (notes.aspx)
luvit.CheckAll_portal_nobg = function CheckAll_portal_nobg(masterCb, cbString) {
  inputArr = document.getElementsByTagName("input");
  for (i = 0; i < inputArr.length; i++) {
    if (
      inputArr[i].type == "checkbox" &&
      inputArr[i].name.indexOf(cbString) >= 1
    )
      inputArr[i].checked = masterCb.checked;
  }
};

luvit.CheckAll_portal = function CheckAll_portal(masterCb, cbString, color) {
  inputArr = document.getElementsByTagName("input");
  for (i = 0; i < inputArr.length; i++) {
    if (
      inputArr[i].type == "checkbox" &&
      inputArr[i].name.indexOf(cbString) >= 1
    ) {
      inputArr[i].checked = masterCb.checked;
    }
  }
};

//Used in course catalogue and news
luvit.CheckAll2 = function CheckAll2(masterCb, cbString) {
  inputArr = document.getElementsByTagName("input");
  for (i = 0; i < inputArr.length; i++) {
    if (
      inputArr[i].type == "checkbox" &&
      inputArr[i].name.indexOf(cbString) != -1
    )
      inputArr[i].checked = masterCb.checked;
  }
};

luvit.InitCheckAll = function InitCheckAll() {
  x = 0;
  listIsEmpty = true;
  inputArr = document.getElementsByTagName("input");
  for (i = 0; i < inputArr.length; i++) {
    if (
      inputArr[i].type == "checkbox" &&
      inputArr[i].name.indexOf(SearchCbId) != -1
    ) {
      listIsEmpty = false;
      if (!inputArr[i].checked) {
        x++;
      }
    }
  }
  if (x == 0 && !listIsEmpty) {
    try {
      document.getElementById(CheckAllId).checked = true;
    } catch (ex) {}
  }
};

//Checkbox behaviour. Called in Recordlist.ascx
//Selects/deselects all checkboxes and updates the counter
luvit.CheckAll = function CheckAll(valueToSet) {
  inputArr = document.getElementsByTagName("input");
  for (i = 0; i < inputArr.length; i++) {
    if (
      inputArr[i].type == "checkbox" &&
      inputArr[i].name.indexOf(SearchCbId) != -1
    ) {
      //This used to not check for if the checkbox was already checked, thus making it counted more than once in total, fixed for 2.5 Nisse
      if (inputArr[i].checked != valueToSet) {
        inputArr[i].checked = valueToSet;
        luvit.CounterChange(valueToSet);
      }
    }
  }
  daObj = document.getElementById(CounterId);
  currentNr = Number(daObj.innerHTML);
  if (currentNr == 0) {
    luvit.UpdateActions("0");
  } else if (currentNr == 1) {
    luvit.UpdateActions("1");
  } else if (currentNr > 1) {
    luvit.UpdateActions("2");
  }
};

//Updates the counter for selected objects.
//Called in Recordlist.ascx
luvit.CounterChange = function CounterChange(daStatus, updateActions) {
  daObj = document.getElementById(CounterId);

  if (daObj) {
    currentNr = parseInt(daObj.innerHTML);
    if (daStatus) currentNr++;
    else if (currentNr > 0) currentNr--;
    daObj.innerHTML = currentNr;

    if (!updateActions) return;

    if (currentNr == 0) {
      luvit.UpdateActions("0");
    } else if (currentNr == 1) {
      luvit.UpdateActions("1");
    } else if (currentNr > 1) {
      luvit.UpdateActions("2");
    }
  }
};

//Function to disable/enable actions on the basis of what is selected in the recordlist
luvit.UpdateActions = function UpdateActions(selectionType) {
  daActionsObj = document.getElementById("actionsContainer");
  if (daActionsObj == null) return;

  daHiddens = daActionsObj.getElementsByTagName("input");
  for (i = 0; i < daHiddens.length; i++) {
    hdn = daHiddens[i];
    if (
      hdn.type == "hidden" &&
      hdn.id.indexOf("hdnselectionTypeAllowed") != -1
    ) {
      typeAllowed = hdn.value;
      if (typeAllowed != "") {
        daActionsObj = hdn.parentNode.getElementsByTagName("a")[0];
        if (selectionType == "0") {
          disableAction(daActionsObj);
        } else if (typeAllowed == "1" && selectionType == "2") {
          disableAction(daActionsObj);
        } else {
          enableAction(daActionsObj);
        }
      }
    }
  }
};
//Helper function to UpdateActions
function disableAction(daObj) {
  if (!daObj) return;
  if (daObj.className.indexOf("disabled") == -1) {
    daObj.className += " disabled";
  }
  daObj.disabled = true;
}
//Helper function to UpdateActions
function enableAction(daObj) {
  if (daObj != null) {
    daObj.className = daObj.className.replace("disabled", "");
    daObj.disabled = false;
  }
}

//Used in recordlist.ascx to perform a client side callback. Updates the value in the "selected items"-counter
luvit.InitSelectedCount = function (counterXmlUrl, pageId) {
  if (!xmlhttp || xmlhttp == null) return;
  if (luvit.callInProgress(xmlhttp)) return;

  myRandom = parseInt(Math.random() * 99999999);
  myUrl = counterXmlUrl + "?random=" + myRandom + "&id=" + pageId;

  xmlhttp.open("GET", myUrl, true);
  xmlhttp.onreadystatechange = function () {
    if (xmlhttp.readyState == 4) {
      if (xmlhttp.status != 200) {
        return;
      } else {
        if (
          xmlhttp.responseText.indexOf("<html>") == -1 &&
          xmlhttp.responseText.indexOf("<html>") == -1
        ) {
          document.getElementById(CounterId).innerHTML = xmlhttp.responseText;
          document.getElementById(CounterId).style.visibility = "visible";

          if (xmlhttp.responseText == "0") {
            luvit.CheckAll(false);
            luvit.UpdateActions("0");
          } else if (xmlhttp.responseText == "1") {
            luvit.UpdateActions("1");
          } else if (Number(xmlhttp.responseText) > 1) {
            luvit.UpdateActions("2");
          }
        }
      }
    }
  };
  xmlhttp.send(null);
};

luvit.SetUniqueRadioButton = function SetUniqueRadioButton(nameregex, current) {
  re = new RegExp(nameregex);
  for (i = 0; i < document.forms[0].elements.length; i++) {
    elm = document.forms[0].elements[i];
    if (elm.type == "radio") {
      if (re.test(elm.name)) {
        var tr;
        if (elm.parentNode) {
          tr = elm.parentNode;
          while (tr.nodeName.toLowerCase() != "tr") tr = tr.parentNode;
        } else if (elm.parentElement) {
          tr = elm.parentElement;
          while (tr.tagName.toLowerCase() != "tr") tr = tr.parentElement;
        }
        if (tr) {
        }
        elm.checked = false;
      }
    }
  }

  current.checked = true;

  var tr2;
  if (current.parentNode) {
    tr2 = current.parentNode;
    while (tr2.nodeName.toLowerCase() != "tr") tr2 = tr2.parentNode;
  } else if (current.parentElement) {
    tr2 = current.parentElement;
    while (tr2.tagName.toLowerCase() != "tr") tr2 = tr2.parentElement;
  }
  if (tr2) {
  }
};

luvit.CheckMe_portal = function CheckMe_portal(me) {
  if (!me.checked) {
    try {
      document.getElementById(CheckAllId).checked = false;
    } catch (ex) {}
  }
};

luvit.CheckMeNoCounter_portal = function CheckMeNoCounter_portal(me, masterCb) {
  if (!me.checked) {
    document.getElementById(masterCb).checked = false;
  }
};

luvit.CheckMe = function CheckMe(me, reverse) {
  if (me.checked) {
    if (reverse) {
      luvit.CounterChange(false, true);
    } else {
      luvit.CounterChange(true, true);
    }
  } else {
    if (reverse) {
      try {
        document.getElementById(CheckAllId).checked = false;
      } catch (ex) {}
      luvit.CounterChange(true, true);
    } else {
      try {
        document.getElementById(CheckAllId).checked = false;
      } catch (ex) {}
      luvit.CounterChange(false, true);
    }
  }
};

luvit.CheckMessagesChecked = function CheckMessagesChecked(text, text2) {
  var chkArray = document.getElementsByTagName("input");

  for (i = 0; i < chkArray.length; i++) {
    if (chkArray[i].id.indexOf("ChkItem") != "-1") {
      if (chkArray[i].checked) return confirm(text2);
    }
  }
  alert(text);
  return false;
};

//Used to check if any checkbox is checked in a specific object.
luvit.CheckAnyChecked = function CheckAnyChecked(
  msgNothingChecked,
  msgConfirm,
  objId,
) {
  var rootObj = document;
  if (objId != null) {
    rootObj = document.getElementById(objId);
    if (rootObj == null) return false;
  }
  var chkArray = rootObj.getElementsByTagName("input");

  for (i = 0; i < chkArray.length; i++) {
    if (chkArray[i].type == "checkbox") {
      if (chkArray[i].checked) {
        if (msgConfirm != "") return confirm(msgConfirm);
        else return true;
      }
    }
  }
  alert(msgNothingChecked);
  return false;
};

//This returns the nr of checked checkboxes in a specific object
luvit.CheckNrOfChecked = function CheckNrOfChecked(objId) {
  var rootObj = document;
  var nrOfCheckedInObj = 0;
  if (objId != null) {
    rootObj = document.getElementById(objId);
    if (rootObj == null) rootObj = $(objId)[0];
  }
  var chkArray = rootObj.getElementsByTagName("input");

  for (i = 0; i < chkArray.length; i++) {
    if (chkArray[i].type == "checkbox") {
      if (chkArray[i].checked) {
        nrOfCheckedInObj++;
      }
    }
  }
  return nrOfCheckedInObj;
};

//Used to check if any checkbox is checked in a specific object.
luvit.CheckAnyCheckedNoConfirm = function CheckAnyCheckedNoConfirm(
  msgNothingChecked,
  objId,
) {
  var rootObj = document;
  if (objId != null) {
    rootObj = document.getElementById(objId);
    if (rootObj == null) return false;
  }
  var chkArray = rootObj.getElementsByTagName("input");

  for (i = 0; i < chkArray.length; i++) {
    if (chkArray[i].type == "checkbox" || chkArray[i].type == "radio") {
      if (chkArray[i].checked) {
        return true;
      }
    }
  }
  alert(msgNothingChecked);
  return false;
};

composemesswin = null;

luvit.ComposeMessage = function ComposeMessage(id, type, courseid, replyall) {
  if (composemesswin == null || composemesswin.closed) {
    var strUrl = require("lib/format").url("/CommCentre/composemessage.aspx");
    if (type != "") {
      strUrl += "?type=" + type;
    } else {
      strUrl += "?type=portal";
    }
    if (id != "") {
      strUrl += "&messageid=" + id;
    }
    if (courseid) {
      strUrl += "&courseid=" + courseid;
    }

    strUrl += "&replyall=" + replyall;

    composemesswin = window.open(
      strUrl,
      "composemesswin",
      "width=780,height=650,resizable=yes,scrollbars=yes",
    );
  } else {
    composemesswin.focus();
  }
};

luvit.ForwardMessage = function ForwardMessage(id, courseid) {
  if (composemesswin == null || composemesswin.closed) {
    var strUrl = require("lib/format").url(
      "/CommCentre/composemessage.aspx?type=portal",
    );

    if (id != "") {
      strUrl += "&messageid=" + id;
    }

    if (courseid) {
      strUrl += "&courseid=" + courseid;
    }

    strUrl += "&forward=1";

    composemesswin = window.open(
      strUrl,
      "composemessage",
      "width=800,height=600,resizable=yes,scrollbars=yes",
    );
  } else {
    composemesswin.focus();
  }
};

//Stuff for the message indicator and the message popup functions.
const MSGCHECKER_ABORT_TIME = 1800000;
luvit.objMsgChecker;

luvit.InitMessageChecker = function InitMessageChecker() {
  clearInterval(luvit.objMsgChecker);
  CheckMessages();
  CheckBadges();
  CheckRatings();
  luvit.objMsgChecker = setInterval(DoIntervalChecks, MsgRequestInterval);

  //Only keep the msgchecker going for 30 minutes
  objMsgCheckerAborter = setTimeout(AbortMessageChecker, MSGCHECKER_ABORT_TIME);
};

function DoIntervalChecks() {
  CheckMessages();
  CheckBadges();
  CheckRatings();
}

//This stops the object that checks for new messages
function AbortMessageChecker() {
  clearInterval(luvit.objMsgChecker);
}

//This resets the timer object that eventually stops message checking
function ResetMsgCheckerAborter() {
  if (typeof objMsgCheckerAborter != "undefined") {
    clearTimeout(objMsgCheckerAborter);
  }
  objMsgCheckerAborter = setTimeout(AbortMessageChecker, MSGCHECKER_ABORT_TIME);
}

function CheckMessages() {
  ajaxSend(
    "GET",
    MessageXmlUrl + "?refresher=" + new Date().getTime(),
    CheckMessages_handleReturn,
    null,
    true,
  );
}

window.checkUnshownBadge = true;
window.checkUnshownBadgeFirstTime = true;

//Handles badges popups
function CheckBadges() {
  if (checkUnshownBadgeFirstTime) {
    checkUnshownBadgeFirstTime = false;
    ajaxSend(
      "GET",
      config.apiUrl + "/v1/gamification/badges/earned",
      Handle_BadgeCheck,
      null,
      false,
    );
  } else if (checkUnshownBadge && !checkUnshownBadgeFirstTime) {
    ajaxSend(
      "GET",
      config.apiUrl + "/v1/gamification/badges/unshownBadge",
      CheckBadges_handleReturn,
      null,
      false,
    );
  }
}

function Handle_BadgeCheck(data) {
  if (JSON.parse(data) == [] || JSON.parse(data) == null) {
    checkUnshownBadge = false;
  } else {
    checkUnshownBadge = true;
    ajaxSend(
      "GET",
      config.apiUrl + "/v1/gamification/badges/unshownBadge",
      CheckBadges_handleReturn,
      null,
      false,
    );
  }
}

//Handles badges popups
function CheckBadges_handleReturn(data) {
  data = JSON.parse(data);
  if (data != null) {
    if (data[0].earnedBadgeID != null) {
      //Pop up the new badge
      fetchContext("Gamification", function () {
        ShowBadgePopup();
      });
    }
  }
}

//Handles ratings popups
function CheckRatings() {
  if (config.ratingPopup == "1") {
    ajaxSend(
      "GET",
      config.apiUrl + "/v1/rating/popup?setShown=false",
      CheckRatings_handleReturn,
      null,
      false,
    );
  }
}

//Handles ratings popups
function CheckRatings_handleReturn(data) {
  data = JSON.parse(data);
  if (data != null) {
    if (data.objectId != null && data.objectId != 0) {
      //Pop up rating dialog for unrated online course
      fetchContext("Activity", function () {
        ShowRatingPopup();
      });
    }
  }
}

function CheckMessages_handleReturn(xmlObj) {
  var counterObj = $(".noofnewmessages");
  if (counterObj != null) {
    var nrUnreadMsgCount = Number(
      luvit.getXmlValue(xmlObj, "messagecount", "val"),
    );
    var hasNewAlerts = luvit.getXmlValue(xmlObj, "hasalerts", "val") == "1";
    var indicatorObj = $(".messagenotification");
    var alertIndicatorObj = $(".alertnotification");

    //counterObj.innerHTML = nrUnreadMsgCount;

    $(counterObj).each(function (i, element) {
      $(element).text(nrUnreadMsgCount);
    });

    if (nrUnreadMsgCount > 0) {
      $(indicatorObj).removeClass("hidden"); //Show the indicator

      var newMsgNode = xmlObj.getElementsByTagName("newmessage")[0];
      myXmlAttributes = luvit.xmlAttributes(newMsgNode);
      var msgId = myXmlAttributes["id"];
      if (msgId != "") {
        //Pop up the new message
        fetchContext("CommCentre", function () {
          ShowMsgPopup(newMsgNode.firstChild.nodeValue);
        });
      }
    } else {
      $(indicatorObj).addClass("hidden");
    }

    if (hasNewAlerts) {
      $(alertIndicatorObj).each(function (i, element) {
        $(element).removeClass("hidden");
      });
    } else {
      $(alertIndicatorObj).each(function (i, element) {
        $(element).addClass("hidden");
      });
    }
  }
}

function ShowBadgePopup() {
  var messageDiv = document.getElementById("divNewMessage");
  if (messageDiv == null) {
    messageDiv = document.createElement("div");
    messageDiv.id = "divNewMessage";
    document.getElementsByTagName("body")[0].appendChild(messageDiv);
    $("#divNewMessage").prop("title", "");
    $("#divNewMessage").html(
      '<iframe scrolling="no" src="' +
        config.urlRoot +
        "Personal/badge_popup.aspx" +
        '" frameborder="0" width="100%" height="100%" background-color="#fff"></iframe>',
    );
    var dialogHeight = Math.floor($(window).height() * 0.6);
    var dialogWidth = "35%";
    var windowWidth = $(window).width();
    if (windowWidth < 500) {
      dialogWidth = "90%";
    }
    dialog = $("#divNewMessage").dialog({
      autoOpen: false,
      height: dialogHeight,
      width: dialogWidth,
      modal: true,
      open: function (event, ui) {
        $("#divNewMessage").css("overflow", "hidden");
        $(event.target).parent().css("background-color", "#fff");
        $(".ui-dialog-buttonpane").css("background-color", "#fff");
        $(".ui-dialog :button").blur();
      },
      close: function () {
        $("body").css("overflow", "auto");
      },
    });
    dialog.dialog("option", "buttons", [
      {
        text: getTranslation("gotomybadges"),
        style:
          "background:transparent !important; border-radius: 10px; color: #065289!important; border-color: transparent!important",
        click: function () {
          location.href = config.urlRoot + "#/tm/coworker/badges";
          $(this).dialog("close");
        },
      },
      {
        text: getTranslation("Close"),
        class: "button-cta",
        style: "padding: 0 20px",
        click: function () {
          $(this).dialog("close");
        },
      },
    ]);
    dialog.dialog("open");
  }
}

function ShowRatingPopup() {
  var messageDiv = document.getElementById("divNewMessage");
  if (messageDiv == null) {
    messageDiv = document.createElement("div");
    messageDiv.id = "divNewMessage";
    document.getElementsByTagName("body")[0].appendChild(messageDiv);
    $("#divNewMessage").prop("title", "");
    $("#divNewMessage").html(
      '<iframe scrolling="no" src="' +
        config.urlRoot +
        "Personal/rating_popup.aspx" +
        '" frameborder="0" width="100%" height="100%" background-color="#fff"></iframe>',
    );
    var dialogHeight = 500;
    var dialogWidth = "35%";
    var windowWidth = $(window).width();
    var windowHeight = $(window).height();
    if (windowWidth < 500) {
      dialogWidth = "90%";
    }
    if (windowWidth > 1800) {
      dialogWidth = "20%";
    }
    if (windowHeight <= 550) {
      dialogHeight = Math.floor($(window).height() * 0.8);
    }
    dialog = $("#divNewMessage").dialog({
      autoOpen: false,
      height: dialogHeight,
      width: dialogWidth,
      modal: true,
      open: function (event, ui) {
        $("#divNewMessage").css("overflow", "hidden");
        $(event.target).parent().css("background-color", "#fff");
        $(".ui-dialog-buttonpane").css("background-color", "#fff");
        $(".ui-dialog :button").blur();
      },
      close: function () {
        $("body").css("overflow", "auto");
      },
    });
    dialog.dialog("option");
    dialog.dialog("open");
  }
}

function ShowMsgPopup(strMsg) {
  if (typeof jQuery != "undefined") {
    var fromId = $("<div />").append(strMsg).find("#hidFromId").val();
    var url = UrlMessageIndicator + "?pid=" + fromId;
    var messageDiv = document.getElementById("divNewMessage");
    if (messageDiv == null) {
      messageDiv = document.createElement("div");
      messageDiv.id = "divNewMessage";
      document.getElementsByTagName("body")[0].appendChild(messageDiv);
      $("#divNewMessage").append("<div id='messageIndicator'></div>");
      $("#divNewMessage").append("<div id='messageIndicatorContent'></div>");
      $("#divNewMessage").dialog({
        bgiframe: true,
        title: getTranslation("newmessage"),
        height: "auto",
        width: "150px",
        position: [50, 50],
        modal: false,
        autoOpen: false,
        draggable: true,
        open: function (event, ui) {
          $(".ui-dialog").css("font-size", "11px");
          $("#messageIndicator").load(url);
          // setTimeout("$('#divNewMessage').dialog('destroy').remove();", 15000);
        },
        overlay: {
          backgroundColor: "#000",
          opacity: 0.5,
        },
      });
    }

    $("#divNewMessage").dialog("open").parent().effect("bounce");
    $("#messageIndicatorContent").html(strMsg);
    ajaxSend("GET", CloseMsgAjaxUrl + "?refresher=" + new Date().getTime());
  } else ShowMsgPopup_no_jquery(strMsg);
}

function ShowMsgPopup_no_jquery(strMsg) {
  var messageDiv = document.getElementById("divNewMessage");
  if (messageDiv == null) {
    messageDiv = document.createElement("div");
    document.getElementsByTagName("body")[0].appendChild(messageDiv);
  }

  messageDiv.className = "newmessage";
  messageDiv.id = "divNewMessage";
  messageDiv.innerHTML = strMsg;

  //Show the course dropdown list on IE
  if (browserIsIE() && IsInCourse) {
    if (getDdlCoursesObj() != null) {
      getDdlCoursesObj().style.display = "none";
    }
  }
}

luvit.CloseMsgPopup = function CloseMsgPopup(daObj) {
  ajaxSend("GET", CloseMsgAjaxUrl + "?refresher=" + new Date().getTime());
  $("#divNewMessage").dialog("close");
  $("#divNewMessage").dialog("destroy");
};

luvit.SetActiveCourseSubMenuItem = function (menuitemid) {
  $(
    ".course.menu .menu-expandlist-item, .course.menu .menu-expandlist-header",
  ).removeClass("active");
  $(".course.menu .menu-icon-collapse")
    .addClass("menu-icon-expand")
    .removeClass("menu-icon-collapse");
  $(".course.menu .menu-expandlist-content").hide();

  item = $(".menu-expandlist-item[data-id='" + menuitemid + "']");

  $(item).closest(".menu-expandlist-content").show();

  var iconToggle = $(item)
    .closest(".menu-expandlist-content")
    .prev()
    .find("[class='menu-icon-expand']");
  $(iconToggle).removeClass();
  $(iconToggle).addClass("menu-icon-collapse");
  $(item).addClass("active");

  var state = { active: menuitemid };

  if (luvit.getItem("luvit_coursemenustate")) {
    var menuState = $.parseJSON(luvit.getItem("luvit_coursemenustate"));
    menuState.active = menuitemid;
    luvit.setItem("luvit_coursemenustate", JSON.stringify(menuState));
  } else luvit.setItem("luvit_coursemenustate", JSON.stringify(state));
};

luvit.OpenAlerts = function OpenAlerts(daObj) {
  OpenWin(AlertsUrl, 320, 320);
  daObj.blur();
  return false;
};

luvit.OpenModalWin = function (url, callback) {
  var mqmobile = window.matchMedia(
    "(max-device-width:" + luvit.mobileBreakPoint + "px)",
  );
  var top = $(window).scrollTop();

  if (!mqmobile.matches) {
    top += 10;
  }

  $("body form").append(
    '<div id="modalwin" style="top:' + top + 'px;" class="dialog"></div>',
  );

  $("#modalwin").load(url, callback);

  $("#DivOverlay").click(function () {
    $(this).remove();
    $("#modalwin").remove();
  });
};

luvit.OpenModalIframeWin = function (iurl, id) {
  //$("#loader").show();

  var url = ""; ///calendar/";
  url += iurl;

  var height = $(window).height() - 200;
  $("body").css("overflow", "hidden");

  if ($("#AddEditEvent").length == 0) {
    $("body").append(
      '<iframe id="' +
        id +
        '" style="height:' +
        height +
        'px;"  class="dialog" src="' +
        url +
        '" frameborder="0"> </iframe>',
    );
  } else {
    $("#" + id + '"').attr("src", iurl);
  }
};

//END Stuff for the message indicator and the message popup functions.

luvit.OpenHelpWin = function OpenHelpWin(url) {
  window.open(
    url,
    "",
    "width=750,height=650,toolbar=yes,scrollbars=yes,resizable=yes",
  );
};

luvit.OpenAlertWin = function OpenAlertWin(url) {
  window.open(
    url,
    "",
    "width=360,height=270,toolbar=no,scrollbars=yes,resizable=no",
  );
};

function OpenWin(url, width, height) {
  window.open(
    url,
    "",
    "width=" + width + ",height=" + height + ",scrollbars=yes,resizable=yes",
  );
  return false;
}

function OpenModalWin(url, width, height, id) {
  var w = width;
  var h = height;
  if ($("#" + id).length == 0) {
    $(
      '<iframe id="' +
        id +
        '" src="' +
        url +
        '" frameborder="0" horizontalscrolling="no" verticalscrolling="yes" scrolling="auto"> </iframe>',
    )
      .dialog({
        autoOpen: true,
        modal: true,
        resizable: false,
        position: ["center", "center"],
        autoResize: false,
        draggable: false,
        overlay: {
          backgroundColor: "#000",
          opacity: 0.5,
        },
        open: function (ev, ui) {
          $(".ui-dialog-titlebar").hide();
        },
      })
      .addClass(".dialog");
  } else {
    $("#" + id).dialog("option", "width", width);
    $("#" + id).attr("src", url);
    $("#" + id)
      .dialog("open")
      .width(width);
  }
}

luvit.OpenEmailWin = function OpenEmailWin() {
  window.open(
    "SendEmail.aspx",
    "",
    "width=400,height=450,scrollbars=no,resizable=yes",
  );
};

luvit.SetBrowserTitle = function SetBrowserTitle(pageTitle) {
  var sitename =
    document.querySelector("#SiteName")?.getAttribute("content") || "Portal";
  document.title = `${pageTitle} - ${sitename}`;
  return pageTitle;
};

//Functions to parse querystring values
function PageQuery(q) {
  if (q.length > 1) this.q = q.substring(1, q.length);
  else this.q = null;

  this.keyValuePairs = new Array();
  if (q) {
    for (var i = 0; i < this.q.split("&").length; i++) {
      this.keyValuePairs[i] = this.q.split("&")[i];
    }
  }

  this.getKeyValuePairs = function () {
    return this.keyValuePairs;
  };

  this.getValue = function (s) {
    for (var j = 0; j < this.keyValuePairs.length; j++) {
      if (this.keyValuePairs[j].split("=")[0] == s)
        return this.keyValuePairs[j].split("=")[1];
    }
    return false;
  };

  this.getParameters = function () {
    var a = new Array(this.getLength());
    for (var j = 0; j < this.keyValuePairs.length; j++) {
      a[j] = this.keyValuePairs[j].split("=")[0];
    }
    return a;
  };
  this.getLength = function () {
    return this.keyValuePairs.length;
  };
}

function queryString(key, srcWin) {
  var page = new PageQuery(srcWin.location.search);
  return unescape(page.getValue(key));
}

function getQueryStringItem(key, srcWin) {
  if (queryString(key, srcWin) == "false") {
    return "_notfound_";
  } else {
    return queryString(key, srcWin);
  }
}

function GetQueryString(key) {
  var e,
    a = /\+/g, // Regex for replacing addition symbol with a space
    r = /([^&=]+)=?([^&|#]*)/g, // Added "#" as a split as it was causing issues
    d = function (s) {
      return decodeURIComponent(s.replace(a, " "));
    },
    q =
      (window.location.href.indexOf("?") >= 0 &&
        window.location.href.split("?")[1]) ||
      "";

  while ((e = r.exec(q)))
    //Is correct, do not change to ==
    urlParams[d(e[1])] = d(e[2]);

  return q.indexOf(key) >= 0 ? urlParams[key] : "";
}

//END Functions to parse querystring values

//Functions to disable/enable and fade/defade links
luvit.disableLink = function (daObj) {
  if (!daObj) return;
  if (daObj.className.indexOf("disabled") == -1) {
    daObj.className += " disabled";
  }
  daObj.disabled = true;
};
luvit.enableLink = function (daObj) {
  daObj.className = daObj.className.replace("disabled", "");
  daObj.disabled = false;
};
luvit.fadeLink = function (daObj) {
  if (!daObj) return;
  if (daObj.className.indexOf("faded") == -1) {
    daObj.className += " faded";
  }
  daObj.disabled = true;
};
luvit.deFadeLink = function (daObj) {
  daObj.className = daObj.className.replace("faded", "");
  daObj.disabled = false;
};
//END Functions to disable/enable and fade/defade links

//Function to check if a link is disabled
luvit.linkIsDisabled = function (daObj) {
  if (daObj.className != null) {
    return daObj.className.indexOf("disabled") != -1;
  } else {
    return true;
  }
};

//Processes xml node attributes into an array and returns it
luvit.xmlAttributes = function (oNode) {
  var tAttributes = {};
  for (var i = 0; i < oNode.attributes.length; ++i)
    tAttributes[oNode.attributes.item(i).name] = oNode.attributes.item(i).value;
  return tAttributes;
};

//returns the value of a specific attribute from a specific node
luvit.getXmlValue = function (xmlObj, nodeName, attName) {
  if (xmlObj) {
    return luvit.xmlAttributes(xmlObj.getElementsByTagName(nodeName)[0])[
      attName
    ];
  }
};

//Function to check for Internet Explorer
luvit.browserIsIE = function () {
  ie = document.all ? true : false;
  return ie;
};

//Scott Andrew's cross browser event handling code
luvit.addEvent = function addEvent(obj, evType, fn, useCapture) {
  if (obj.addEventListener) {
    obj.addEventListener(evType, fn, useCapture);
    return true;
  } else if (obj.attachEvent) {
    var r = obj.attachEvent("on" + evType, fn);
    return r;
  } else {
    //alert("Handler could not be attached");
  }
};

//Function to dynamically add onload-events to document body
luvit.addLoadEvent = function (func) {
  luvit.addEvent(window, "load", func);
};

function removeEvent(obj, evType, fn, useCapture) {
  if (obj.removeEventListener) {
    obj.removeEventListener(evType, fn, useCapture);
    return true;
  } else if (obj.detachEvent) {
    var r = obj.detachEvent("on" + evType, fn);
    return r;
  } else {
    //alert("Handler could not be removed");
  }
}
//END Scott Andrew's cross browser event handling code

/*Function that adds a style rule to the provided document object*/
function createStyleRule(oDoc, selector, declaration) {
  if (
    !oDoc.getElementsByTagName ||
    !(oDoc.createElement || oDoc.createElementNS)
  )
    return;
  var agt = navigator.userAgent.toLowerCase();
  var is_ie = agt.indexOf("msie") != -1 && agt.indexOf("opera") == -1;
  var is_iewin = is_ie && agt.indexOf("win") != -1;
  var is_iemac = is_ie && agt.indexOf("mac") != -1;
  if (is_iemac) return; // script doesn't work properly in IE/Mac
  var head = oDoc.getElementsByTagName("head")[0];
  var style =
    typeof oDoc.createElementNS != "undefined"
      ? oDoc.createElementNS("http://www.w3.org/1999/xhtml", "style")
      : oDoc.createElement("style");
  if (!is_iewin) {
    var styleRule = oDoc.createTextNode(selector + " {" + declaration + "}");
    style.appendChild(styleRule); // bugs in IE/Win
  }
  style.setAttribute("type", "text/css");
  style.setAttribute("media", "screen");
  head.appendChild(style);
  if (is_iewin && oDoc.styleSheets && oDoc.styleSheets.length > 0) {
    var lastStyle = oDoc.styleSheets[oDoc.styleSheets.length - 1];
    if (typeof lastStyle.addRule == "object") {
      lastStyle.addRule(selector, declaration);
    }
  }
}

// threadsafe asynchronous XMLHTTPRequest code
window.ajaxSend = function (
  sendMethod,
  url,
  callback,
  objToSend,
  returnXml,
  asyncCall,
  setUtf8Header,
  wrappedCallback,
) {
  if (typeof asyncCall == "undefined") {
    asyncCall = true;
  }
  if (typeof setUtf8Header == "undefined") {
    setUtf8Header = false;
  }
  if (typeof wrappedCallback == "undefined") {
    wrappedCallback = function () {};
  }
  // we use a javascript feature here called "inner functions"
  // using these means the local variables retain their values after the outer function
  // has returned. this is useful for thread safety, so
  // reassigning the onreadystatechange function doesn't stomp over earlier requests.

  function ajaxBindCallback() {
    if (ajaxRequest.readyState == 4) {
      if (ajaxRequest.status == 200) {
        if (ajaxCallback) {
          //If the user has been logged out, the html of the default aspx page will be returned.
          //Check for the presence of a "DOCTYPE"-string. This will most likely mean that the user has been logged out.
          if (
            ajaxRequest.responseText
              .toLowerCase()
              .indexOf("doctype html public") > -1
          ) {
            return;
          }

          if (returnXml) {
            ajaxCallback(ajaxRequest.responseXML, wrappedCallback);
          } else {
            ajaxCallback(ajaxRequest.responseText, wrappedCallback);
          }
        } else {
          //alert('_no callback defined');
        }
      } else {
        //alert("_There was a problem retrieving the xml data:\n" + ajaxRequest.status + ":\t" + ajaxRequest.statusText + "\n" + ajaxRequest.responseText);
      }
    }
  }

  // use a local variable to hold our request and callback until the inner function is called...
  var ajaxRequest = null;
  var ajaxCallback = callback;
  // bind our callback then hit the server...
  if (window.XMLHttpRequest) {
    // moz et al
    ajaxRequest = new XMLHttpRequest();
    ajaxRequest.onreadystatechange = ajaxBindCallback;
    ajaxRequest.open(sendMethod, url, asyncCall);
    if (objToSend) {
      if (setUtf8Header) {
        ajaxRequest.setRequestHeader(
          "Content-Type",
          "application/x-www-form-urlencoded; charset=utf-8",
        );
      }
      ajaxRequest.send(objToSend);
    } else {
      ajaxRequest.send(null);
    }
  } else if (window.ActiveXObject) {
    // ie
    ajaxRequest = new ActiveXObject("Microsoft.XMLHTTP");
    if (ajaxRequest) {
      ajaxRequest.onreadystatechange = ajaxBindCallback;
      ajaxRequest.open(sendMethod, url, true);
      if (objToSend) {
        //If the post method is used, set the proper header
        if (sendMethod.toLowerCase() == "post") {
          ajaxRequest.setRequestHeader(
            "Content-Type",
            "application/x-www-form-urlencoded; charset=UTF-8",
          );
        }
        ajaxRequest.send(objToSend);
      } else {
        ajaxRequest.send(null);
      }
    }
  }
};
luvit.handleScormSaveCallback = function (responseObj) {
  if (scormdebug) {
    alert(responseObj);
  }
};

luvit.handleScormSaveCallback2004 = function (responseObj) {
  if (debug2004) {
    alert(responseObj);
  }
};

//Ska tas bort
function ajaxSend2(
  sendMethod,
  url,
  callback,
  objToSend,
  returnXml,
  asyncCall,
  setUtf8Header,
) {
  if (typeof asyncCall == "undefined") {
    asyncCall = true;
  }
  if (typeof setUtf8Header == "undefined") {
    setUtf8Header = false;
  }
  // we use a javascript feature here called "inner functions"
  // using these means the local variables retain their values after the outer function
  // has returned. this is useful for thread safety, so
  // reassigning the onreadystatechange function doesn't stomp over earlier requests.

  function ajaxBindCallback() {
    if (ajaxRequest.readyState == 4) {
      if (ajaxRequest.status == 200) {
        if (ajaxCallback) {
          //If the user has been logged out, the html of the default aspx page will be returned.
          //Check for the presence of a "DOCTYPE"-string. This will most likely mean that the user has been logged out.
          if (
            ajaxRequest.responseText
              .toLowerCase()
              .indexOf("doctype html public") > -1
          ) {
            return;
          }

          if (returnXml) {
            ajaxCallback(ajaxRequest.responseXML);
          } else {
            ajaxCallback(ajaxRequest.responseText);
          }
        } else {
          //alert('_no callback defined');
        }
      } else {
        //alert("_There was a problem retrieving the xml data:\n" + ajaxRequest.status + ":\t" + ajaxRequest.statusText + "\n" + ajaxRequest.responseText);
      }
    }
  }

  // use a local variable to hold our request and callback until the inner function is called...
  var ajaxRequest = null;
  var ajaxCallback = callback;
  // bind our callback then hit the server...
  if (window.XMLHttpRequest) {
    // moz et al
    ajaxRequest = new XMLHttpRequest();
    ajaxRequest.onreadystatechange = ajaxBindCallback;
    ajaxRequest.open(sendMethod, url, asyncCall);
    if (objToSend) {
      if (setUtf8Header) {
        ajaxRequest.setRequestHeader(
          "Content-Type",
          "application/x-www-form-urlencoded; charset=utf-8",
        );
      }
      //alert("Save: "+url+"  "+(new XMLSerializer()).serializeToString(objToSend));
      ajaxRequest.send(objToSend);
    } else {
      //alert("Save: "+ url);
      ajaxRequest.send(null);
    }
  } else if (window.ActiveXObject) {
    // ie
    ajaxRequest = new ActiveXObject("Microsoft.XMLHTTP");
    if (ajaxRequest) {
      ajaxRequest.onreadystatechange = ajaxBindCallback;
      ajaxRequest.open(sendMethod, url, true);
      if (objToSend) {
        //If the post method is used, set the proper header
        if (sendMethod.toLowerCase() == "post") {
          ajaxRequest.setRequestHeader(
            "Content-Type",
            "application/x-www-form-urlencoded; charset=UTF-8",
          );
        }
        ajaxRequest.send(objToSend);
      } else {
        ajaxRequest.send(null);
      }
    }
  }
}

luvit.getStartXml = function (url) {
  var ajaxRequest = null;
  ajaxRequest = new XMLHttpRequest();
  //ajaxRequest.open("GET", url, true);

  var strXml = "";

  jQuery.ajaxSetup({ async: false });
  $.get(url, function (data) {
    strXml = data;
  });
  jQuery.ajaxSetup({ async: true });
  return strXml;
  /*ajaxRequest.onload = function () {
            if (ajaxRequest.status === 200) {
                var str = ajaxRequest.responseText;
                //alert("Loaded: "+str);
                if (window.DOMParser) {
                    return ajaxRequest.responseXML;
                    //return (new DOMParser()).parseFromString(str, "text/xml");
                }
                else {
                    var xmlDoc = new ActiveXObject("Microsoft.XMLDOM");
                    xmlDoc.async = false;
                    xmlDoc.loadXML(str);
                    return xmlDoc;
                }
            }
            else {
                return "";
            }
        };


        ajaxRequest.send();*/
  //if (ajaxRequest.status == 200) {
  //    var str = ajaxRequest.responseText;
  //    //alert("Loaded: "+str);
  //    if (window.DOMParser) {
  //        return ajaxRequest.responseXML;
  //        //return (new DOMParser()).parseFromString(str, "text/xml");
  //    }
  //    else {
  //        var xmlDoc = new ActiveXObject("Microsoft.XMLDOM");
  //        xmlDoc.async = false;
  //        xmlDoc.loadXML(str);
  //        return xmlDoc;
  //    }
  //}
  //else {
  //    return "";
  //}
};

//The code below is still in use by some functions

luvit.getXmlHttpRequestObj = function () {
  //CODE TO CREATE XMLHTTPREQUEST OBJECT
  var daObj = false;
  /*@cc_on @*/
  /*@if (@_jscript_version >= 5)
        // JScript gives us Conditional compilation, we can cope with old IE versions.
        // and security blocked creation of the objects.
        try
        {
            daObj = new ActiveXObject("Msxml2.XMLHTTP");
        }
        catch (e)
        {
            try
            {
                daObj = new ActiveXObject("Microsoft.XMLHTTP");
            }
            catch (E)
            {
                daObj = false;
            }
        }
        @end @*/
  if (!daObj && typeof XMLHttpRequest != "undefined") {
    daObj = new XMLHttpRequest();
  }
  if (!daObj && browserIsIE())
    alert(
      'Could not create the xml object. To use this page you must adjust the security settings in your browser to "medium"',
    );

  return daObj;
  //END CODE TO CREATE XMLHTTPREQUEST OBJECT
};
window.xmlhttp = luvit.getXmlHttpRequestObj();

luvit.callInProgress = function (myXmlHttp) {
  //alert("\"" + xmlhttp.readyState + "\"" );
  switch (myXmlHttp.readyState) {
    case 1:
      return true;
      break;
    case 2:
      return true;
      break;
    case 3:
      return true;
      break;
    //case 0 or 4
    default:
      return false;
      break;
  }
};

//This hooks up a fixed version of WebForm_FireDefaultButton ;
try {
  addEvent(window, "load", SetNewDefaultButtonScript);
} catch (ex) {}
var __defaultFired = false; //Fix after.NET patch 2006-10

function SetNewDefaultButtonScript() {
  WebForm_FireDefaultButton = WebForm_FireDefaultButton_LUVIT;
}

function WebForm_FireDefaultButton_LUVIT(event, target) {
  if (
    !__defaultFired &&
    event.keyCode == 13 &&
    !(event.srcElement && event.srcElement.tagName.toLowerCase() == "textarea")
  ) {
    var defaultButton;
    if (__nonMSDOMBrowser) {
      defaultButton = document.getElementById(target);
    } else {
      defaultButton = document.all[target];
    }
    if (defaultButton && typeof defaultButton.click != "undefined") {
      __defaultFired = true;
      defaultButton.click();
      event.cancelBubble = true;
      if (event.stopPropagation) event.stopPropagation();
      return false;
    } else if (defaultButton && defaultButton.tagName.toLowerCase() == "a") {
      //We're dealing with a linkbutton and must activate the href, rather than triggering the click event
      eval(defaultButton.href);
      //top.location = defaultButton.href;
      event.cancelBubble = true;
      if (event.stopPropagation) event.stopPropagation();
      return false;
    }
  }
}

luvit.ViewAttachment = function (url) {
  window.open(url, "", "width=700,height=500,scrollbars=yes,resizable=yes");
};

luvit.openRSS = function (strUrl) {
  window.open(strUrl, "", "width=700,height=500,resizable=yes,scrollbars=yes");
};
function noAction() {
  //Used to set href to noaction value.
}

//Saves the active tab of the Ajax tabcontainer on postback
function OnClientActiveTabChanged(sender, args) {
  sender.get_clientStateField().value = sender.saveClientState();
}

//Validates date in ajax calendar extender
function CalendarExtenderDate_Validate(sender, args) {
  args.Value.match(/^(\d+)-(\d+)-(\d+)$/);

  var yyyy = RegExp.$1;
  var MM = RegExp.$2 - 1;
  var dd = RegExp.$3;

  dte = new Date(yyyy, MM, dd);

  args.IsValid = false;
  if (dte.getFullYear() == yyyy && dte.getMonth() == MM && dte.getDate() == dd)
    args.IsValid = true;
}

luvit.getLuvitTopPage = function () {
  try {
    return self.getLuvitTopPageRecursiveWithALongNameThatIsUnlikelyToBeFoundElsewhere(
      1,
    );
  } catch (e) {
    // This can be caused by differences between http and https in the frames.
    // Thus it will not work right if Luvits top frame is in a parent frame.
    return top;
  }
};

self.getLuvitTopPageRecursiveWithALongNameThatIsUnlikelyToBeFoundElsewhere =
  function getLuvitTopPageRecursiveWithALongNameThatIsUnlikelyToBeFoundElsewhere(
    level,
  ) {
    if (
      self == top ||
      !parent ||
      !parent.getLuvitTopPageRecursiveWithALongNameThatIsUnlikelyToBeFoundElsewhere
    ) {
      return self;
    } else {
      //alert("LuvitTopPage search level => " + level + ", url" + document.URL);
      return parent.getLuvitTopPageRecursiveWithALongNameThatIsUnlikelyToBeFoundElsewhere(
        level + 1,
      );
    }
  };

global.URLEncode = function URLEncode(string) {
  string = string.replace(/\r\n/g, "\n");
  var utftext = "";

  for (var n = 0; n < string.length; n++) {
    var c = string.charCodeAt(n);

    if (c < 128) {
      utftext += String.fromCharCode(c);
    } else if (c > 127 && c < 2048) {
      utftext += String.fromCharCode((c >> 6) | 192);
      utftext += String.fromCharCode((c & 63) | 128);
    } else {
      utftext += String.fromCharCode((c >> 12) | 224);
      utftext += String.fromCharCode(((c >> 6) & 63) | 128);
      utftext += String.fromCharCode((c & 63) | 128);
    }
  }

  return utftext;
};

/*Om str1 finns i str så ersätts den med str2. Om str2 finns så ersätts den med str1*/
luvit.replace = function (str, str1, str2) {
  var index = str.indexOf(str1);

  if (index != -1) {
    var before = str.substring(0, index);
    var after = str.substr(index + str1.length, str.length);
    return before + str2 + after;
  } else {
    index = str.indexOf(str2);
    if (index != -1) {
      var before = str.substring(0, index);
      var after = str.substr(index + str2.length, str.length);
      return before + str1 + after;
    }
  }
};

//Chrome fix for dynamically loaded javascripts
if (typeof Sys != "undefined") {
  Sys.Browser.WebKit = {};
  if (navigator.userAgent.indexOf("WebKit/") > -1) {
    Sys.Browser.agent = Sys.Browser.WebKit;
    Sys.Browser.version = parseFloat(
      navigator.userAgent.match(/WebKit\/(\d+(\.\d+)?)/)[1],
    );
    Sys.Browser.name = "WebKit";
  }
}

luvit.Utf8Encode = function (string) {
  string = string.replace(/\r\n/g, "\n");
  var utftext = "";

  for (var n = 0; n < string.length; n++) {
    var c = string.charCodeAt(n);

    if (c < 128) {
      utftext += String.fromCharCode(c);
    } else if (c > 127 && c < 2048) {
      utftext += String.fromCharCode((c >> 6) | 192);
      utftext += String.fromCharCode((c & 63) | 128);
    } else {
      utftext += String.fromCharCode((c >> 12) | 224);
      utftext += String.fromCharCode(((c >> 6) & 63) | 128);
      utftext += String.fromCharCode((c & 63) | 128);
    }
  }

  return utftext;
};

function DisableLinks() {
  $('a[disabled="disabled"]').css("color", "#999");
  $('a :hover[disabled="disabled"]').css("text-decoration", "none");
}

luvit.SlideUp = function SlideUp(obj) {
  $(obj).slideUp();
};

luvit.InitCheckbox = function InitCheckbox(obj) {
  $(obj).click(function () {
    var tbl = $(this).closest("table");
    if ($(this).is(":checked")) {
      var noOfCheckboxes = $(tbl)
        .find("td")
        .find('input[type="checkbox"]').length;
      var noOfChecked = $(tbl).find("td").find("input:checked").length;

      if (noOfChecked == noOfCheckboxes)
        $(tbl).find(".chkallitems").attr("checked", "checked");

      $(this).closest("tr").removeAttr("style");
      $(this).closest("tr").addClass("selected");
    } else {
      $(tbl).find(".chkallitems").removeAttr("checked");
      $(this).closest("tr").removeClass("selected");
    }
  });
};

luvit.isiPad = function isiPad() {
  return navigator.platform.indexOf("iPad") != -1;
};

luvit.isiPhone = function isiPhone() {
  return navigator.userAgent.match(/iPhone/i);
};

luvit.isiPadOriPhone = function isiPadOriPhone() {
  if (
    navigator.userAgent.match(/iPhone/i) ||
    navigator.userAgent.match(/iPad/i)
  ) {
    return true;
  }

  return false;
};

luvit.overlayTimer;

luvit.InitAjaxLoadingOverlay = function InitAjaxLoadingOverlay(element) {
  $("body").append('<div id="DivOverlay"></div>');

  $("#DivOverlay").hide();

  $(element)
    .ajaxStart(function () {
      var height = $(document).height();
      $("#DivOverlay").height(height);
      luvit.overlayTimer = setTimeout(
        '$("#DivOverlay").show()',
        ajaxLoaderWait,
      );
    })
    .ajaxStop(function () {
      clearTimeout(luvit.overlayTimer);
      $("#DivOverlay").hide();
    });
};

luvit.InitAjaxLoadingOverlay3 = function InitAjaxLoadingOverlay3() {
  $("body").append('<div id="DivOverlay"></div>');

  $("#DivOverlay").hide();

  $(document)
    .ajaxStart(function () {
      var height = $(document).height();
      $("#DivOverlay").height(height);
      luvit.overlayTimer = setTimeout('$("#DivOverlay").show()', 0);
    })
    .ajaxStop(function () {
      clearTimeout(luvit.overlayTimer);
      $("#DivOverlay").hide();
    });
};

luvit.InitLoader = function InitLoader() {
  var top = luvit.getLuvitTopPage();

  var loader = top.$("body").find(".loadingoverlay");

  if (loader.length == 0)
    top.$("body").append('<div class="loadingoverlay" ></div>');

  $(".loadingoverlay").hide();

  $(document)
    .ajaxStart(function () {
      luvit.overlayTimer = setTimeout(
        'top.$(".loadingoverlay").show()',
        ajaxLoaderWait,
      );
    })
    .ajaxStop(function () {
      clearTimeout(luvit.overlayTimer);
      top.$(".loadingoverlay").hide();
    });
};

luvit.OpenModalWinWithTitleCustom = function OpenModalWinWithTitleCustom(
  title,
  url,
  width,
  height,
  id,
  inIframe,
) {
  var w = width;
  var h = height;
  var dWidth = $(window).width() * 0.7;
  var maxWidth = 1000;
  var topOffset = "100";
  var overflow = "none";

  if (luvit.mqMobile.matches) {
    dWidth = $(window).width();
    maxWidth = $(window).width();
    overflow = "auto";

    //position = { my: "left top", at: "left top+120", of: $("body") };
  } else {
    dWidth = width;
  }

  var offSet = $(window).scrollTop();
  /*
        var offSet = $("body").scrollTop();

        if (offSet == 0)
            offSet = $("html").scrollTop();
            */

  if (offSet != 0) topOffset = offSet;

  //var position = { my: "center top", at: "center top", of: "body" };
  var theposition = { my: "left top", at: "left+50 top", of: $("body") };
  var menu = $(".portal.menu");
  if (menu != null) {
    if ($(".portal.menu").hasClass("selected")) {
      theposition = { my: "left center", at: "left+320 top+100" };
    } else {
      theposition = { my: "left top", at: "left+50 top", of: $("body") };
    }
  }
  /*
        if (!inIframe && !luvit.mqMobile.matches) {
            if ($(".portal.menu").hasClass("selected")) {
                position = { my: "left top", at: "left+350 top+100",of: $("body") };
            }
            else {
                position = { my: "left top", at: "left+50 top+100", of: $("body") };
            }
        }
        */
  $(
    '<iframe id="' +
      id +
      '" src="' +
      url +
      '" style="margin:0;padding:0;overflow:auto" frameborder="0" horizontalscrolling="no" verticalscrolling="yes" scrolling="auto"> </iframe>',
  )
    .dialog({
      autoOpen: true,
      width: dWidth,
      minHeight: h,
      modal: true,
      resizable: true,
      position: theposition,
      autoResize: false,
      draggable: true,
      title: title,
      open: function (evt, ui) {
        $(evt.target).parent().css("top", topOffset);
      },
      create: function (event, ui) {
        $(this).parent().css("maxWidth", maxWidth);
        $(this).parent().css("overflow", overflow);
      },
      overlay: {
        backgroundColor: "#000",
        opacity: 0.5,
      },
    })
    .bind("dialogdragstart dialogresizestart", function () {
      var div = $(this).parent();
      var overlay = $(div).find(".hidden-dialog-overlay");
      if (!overlay.length) {
        overlay = $(
          '<div class="hidden-dialog-overlay" style="position:absolute;top:0;left:0;right:0;bottom:0;z-order:100000;"></div>',
        );
        overlay.appendTo(div);
      } else overlay.show();
    })
    .bind("dialogdragstop dialogresizestop", function () {
      var div2 = $(this).parent();
      $(div2).find(".hidden-dialog-overlay").hide();
    })
    .width(w);
};

//UI SETTINGS************************************************************

$(document).ready(function () {
  if (typeof showPanelHeaderHelp !== "undefined") {
    if (showPanelHeaderHelp == 0) $(".panelheaderhelp").hide();

    if (showEventTypeIcon == 0) $(".schedule .icon").hide();
  }
});

luvit.GlobalEndRequest = function GlobalEndRequest() {
  if (showPanelHeaderHelp == 0) $(".panelheaderhelp").hide();

  if (showEventTypeIcon == 0) $(".schedule .icon").hide();
};

//***********************************************************************

/*From admin_scripts*/
luvit.SetNewDefaultButtonScriptBase = function () {
  __defaultFired = false;
  WebForm_FireDefaultButton = WebForm_FireDefaultButton_LUVIT;
};

luvit.SetNewDefaultButtonScript = function () {
  WebForm_FireDefaultButton = WebForm_FireDefaultButton_LUVIT;
};

function WebForm_FireDefaultButton_LUVIT(event, target) {
  if (
    !__defaultFired &&
    event.keyCode == 13 &&
    !(event.srcElement && event.srcElement.tagName.toLowerCase() == "textarea")
  ) {
    var defaultButton;
    if (__nonMSDOMBrowser) {
      defaultButton = document.getElementById(target);
    } else {
      defaultButton = document.all[target];
    }
    if (defaultButton && typeof defaultButton.click != "undefined") {
      __defaultFired = true;
      defaultButton.click();
      event.cancelBubble = true;
      if (event.stopPropagation) event.stopPropagation();
      return false;
    } else if (defaultButton && defaultButton.tagName.toLowerCase() == "a") {
      //We're dealing with a linkbutton and must activate the href, rather than triggering the click event
      eval(defaultButton.href);
      //top.location = defaultButton.href;
      event.cancelBubble = true;
      if (event.stopPropagation) event.stopPropagation();
      return false;
    }
  }
}

luvit.UpdateActionsForTree = function UpdateActionsForTree() {
  if (nrOfCheckedTreeNodes <= 0) {
    luvit.UpdateActions("0");
  } else if (nrOfCheckedTreeNodes == 1) {
    luvit.UpdateActions("1");
  } else if (nrOfCheckedTreeNodes > 1) {
    luvit.UpdateActions("2");
  }
};

luvit.CheckAnythingCheckedInTreeOnlyOneAllowed =
  function CheckAnythingCheckedInTreeOnlyOneAllowed(
    ctrl,
    msgNothingChecked,
    msgSelectOneOnly,
  ) {
    if (nrOfCheckedTreeNodes > 0) {
      if (nrOfCheckedTreeNodes > 1) {
        alert(msgSelectOneOnly);
        return false;
      }
      return true;
    }

    alert(msgNothingChecked);
    return false;
  };

luvit.openWinInCenter = function openWinInCenter(url, width, height, usemenu) {
  if (width == null) width = 800;
  if (height == null) height = 600;
  winAttributes = ",status=1,toolbar=0,scrollbars=1,resizable=1";
  if (usemenu != null && usemenu == true) winAttributes += ",menubar=1";

  //This opens the window centered
  var n = window.open(
    url,
    "",
    "width=" +
      width +
      ",height=" +
      height +
      ",left=" +
      (screen.width - width) / 2 +
      ",top=" +
      (screen.height - height) / 3 +
      winAttributes,
  );

  //This does not position the new window
  //var n = window.open(url,'','width=' + width + ',height=' + height + winAttributes);

  n.focus();
};

//Used in course catalogue and news
luvit.CheckMeNoCounter = function CheckMeNoCounter(me, masterCb) {
  if (!me.checked) {
    document.getElementById(masterCb).checked = false;
  }
};

//Used for course catalogue and news
luvit.CheckAnythingChecked = function CheckAnythingChecked(
  ctrl,
  msgNothingChecked,
  msgConfirm,
) {
  var chkArray = document.getElementsByTagName("input");

  for (i = 0; i < chkArray.length; i++) {
    if (chkArray[i].id.indexOf(ctrl) != "-1") {
      if (chkArray[i].checked) {
        return confirm(msgConfirm);
      }
    }
  }
  alert(msgNothingChecked);
  return false;
};

luvit.printPreviewIE11 = function printPreviewIE11() {
  var OLECMDID = 7;
  /* OLECMDID values:    * 6 - print    * 7 - print preview    * 1 - open window    * 4 - Save As    */
  var PROMPT = 1; // 2-DONTPROMPTUSER
  var WebBrowser =
    '<OBJECT ID="WebBrowser1" WIDTH=0 HEIGHT=0 CLASSID="CLSID:8856F961-340A-11D0-A96B-00C04FD705A2"></OBJECT>';
  document.body.insertAdjacentHTML("beforeEnd", WebBrowser);
  WebBrowser1.ExecWB(OLECMDID, PROMPT);
  WebBrowser1.outerHTML = "";
  return false;
};

luvit.onCalendarShown = function (calendar) {
  var top =
    $("#" + calendar._element.id).offset().top +
    $("#" + calendar._element.id).height() +
    5;
  $("#" + calendar._container.id).css({ top: top + "px" });
};

// Add a new function to set the HTML language attribute
luvit.setHtmlLanguage = function (culture) {
  // Get the html element
  const htmlElement = document.documentElement;

  // Set the lang attribute using config.culture
  if (culture) {
    htmlElement.setAttribute("lang", culture);
  }
};
